module.exports = __webpack_public_path__ + "static/img/yjzd-01.8c83a9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yjzd-01.svg
// module id = U/pP
// module chunks = 1